module.exports = (__webpack_require__(5))(2667);